module.exports = __webpack_public_path__ + "img/jk.28f7f706.png";